import { getNewCar } from "@/api/panel";

function renderNewCar(data) {
  return {
    onSaleList: [],
    foreList: data
  };
}

export default {
  namespaced: true,
  state: {
    newCar: {
      onSaleList: [],
      foreList: []
    }
  },
  mutations: {
    SET_NEWCAR: (state, data) => {
      state.newCar = data || {};
    }
  },
  actions: {
    getNewCar({ commit, state }, data) {
      if (state.newCar.onSaleList.length > 0) return;
      getNewCar(data).then(response => {
        const { data } = response.data || {};
        if (data) commit("SET_NEWCAR", renderNewCar(data) || {});
      });
    }
  }
};
